<template>
  <v-card rounded="lg" elevation="1" class="pa-5 mt-4">

    <!-- Header -->
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="text-overline text-medium-emphasis">Feedback</div>
      <v-btn
        v-if="savedOnce && collapsedRate"
        variant="text"
        size="small"
        density="compact"
        append-icon="mdi-chevron-down"
        @click="collapsedRate = false"
      >
        S-a schimbat ceva?
      </v-btn>
      <v-btn
        v-else-if="savedOnce && !collapsedRate"
        variant="text"
        size="small"
        density="compact"
        icon="mdi-chevron-up"
        @click="collapsedRate = true"
      />
    </div>

    <!-- Compact summary (feedback already given, form collapsed) -->
    <div v-if="savedOnce && collapsedRate" class="text-h6">
      {{ EMOJI[selectedRate] }}
    </div>

    <!-- Full form (no feedback yet, or user expanded) -->
    <template v-else>
      <p class="text-body-2 mb-4">Cât de bine surprinde acest raport compatibilitatea voastră?</p>

      <div class="d-flex gap-2 mb-4">
        <v-btn
          v-for="n in 5"
          :key="n"
          :variant="selectedRate === n ? 'flat' : 'tonal'"
          :color="selectedRate === n ? 'primary' : 'default'"
          size="small"
          icon
          :disabled="saving"
          @click="selectedRate = n"
        >
          {{ EMOJI[n] }}
        </v-btn>
      </div>

      <v-expand-transition>
        <v-textarea
          v-if="selectedRate !== null"
          v-model="comment"
          :label="selectedRate <= 3 ? 'Ce nu se potrivește?' : 'Ce a surprins bine?'"
          rows="2"
          auto-grow
          variant="outlined"
          density="compact"
          class="mb-3"
          :disabled="saving"
        />
      </v-expand-transition>

      <div class="d-flex align-center gap-3">
        <v-btn
          color="primary"
          variant="tonal"
          size="small"
          :disabled="selectedRate === null"
          :loading="saving"
          @click="submit"
        >
          {{ savedOnce ? 'Actualizează' : 'Trimite' }}
        </v-btn>
        <v-fade-transition>
          <span v-if="showThanks" class="text-body-2 text-medium-emphasis">Mulțumim!</span>
        </v-fade-transition>
      </div>
    </template>

  </v-card>
</template>

<script>
import apiService from '@/services/ApiService'

const EMOJI = Object.freeze({ 1: '😞', 2: '😕', 3: '😐', 4: '🙂', 5: '😊' })

export default {
  name: 'MatchFeedbackCard',

  props: {
    /**
     * ID of the match being rated.
     * @type {number}
     */
    matchId: {
      type: Number,
      required: true,
    },

    /**
     * Previously saved rating for this user's perspective (1–5), or null if none.
     * @type {number|null}
     */
    initialRate: {
      type: Number,
      default: null,
    },

    /**
     * Previously saved comment, or null.
     * @type {string|null}
     */
    initialComment: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      EMOJI,
      selectedRate: this.initialRate,
      comment: this.initialComment ?? '',
      saving: false,
      savedOnce: this.initialRate !== null,
      collapsedRate: this.initialRate !== null,
      showThanks: false,
    }
  },

  methods: {

    /**
     * Submits or updates the rating for this match, then collapses the form.
     * @returns {Promise<void>}
     */
    async submit() {
      if (!this.selectedRate) return
      this.saving = true
      try {
        await apiService.saveMatchRating(this.matchId, this.selectedRate, this.comment || null)
        this.savedOnce = true
        this.collapsedRate = true
        this.showThanks = true
        setTimeout(() => { this.showThanks = false }, 2000)
      } catch (err) {
        console.error('MatchFeedbackCard > submit error:', err)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
